module.exports = __webpack_public_path__ + "img/stock_comments.a158da35.png";